import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { t } from '../../../modules/infra/i18n';

import {
  canUserViewShopDetails,
} from '../../common/helpers/users';
import {
  deleteShopBankAccount,
  fetchShopBalance,
  getShopBankAccount,
  initiateShopInstantPayout,
  requestShopDebitCard,
} from '../settings/actions';
import { showNotification } from '../../common/helpers/notifications';
import BankAccount from '../settings/bankAccount/bankAccount';
import BarberSettingsContainer from '../settings/barberSettings/BarberSettingsTableContainer';
import ChangePassword from '../settings/changePassword/changePassword';
import Commission from '../settings/commission';
import DiscountList from '../settings/discounts/containers/DiscountList';
import EditShop from '../shops/editShop';
import LoyaltyForm from '../settings/loyalty/container/LoyaltyForm';
import Settings from '../settings/settings';
import Taxes from '../settings/taxes/Taxes';
import WaitingList from '../settings/waitingList/WaitingListContainer';
import PromoCodes from '../settings/promoCodes/PromoCodes';
import AutoPayout from '../settings/autoPayout';
import BrandPaymentSettings from '../settings/brandSettings/components/BrandPaymentSettings';
import { UserSettings } from '../../../modules/shared/auth/two-fa/user-settings';

class ShopUserSettingsWrapper extends Component {
  getPages = () => {
    const pages = {
      'edit-shop': {
        component: (<EditShop />),
        title: t('settings:pages.shop_details'),
      },
      barber: {
        component: (<BarberSettingsContainer />),
        title: t('settings:pages.barber_settings'),
      },
      'bank-account': {
        component: (
          <BankAccount
            fetchAccount={this.fetchBankAccount}
            deleteAccount={this.deleteBankAccount}
            fetchDebitCard={this.fetchDebitCard}
            fetchBalance={this.fetchBalance}
            initiateInstantPayout={this.initiateInstantPayout}
          />
        ),
        title: t('settings:pages.payment_processing'),
      },
      taxes: {
        component: (<Taxes />),
        title: t('settings:pages.taxes'),
      },
      user: {
        component: (<UserSettings />),
        title: t('settings:pages.user_settings'),
      },
      'change-password': {
        component: (<ChangePassword />),
        title: t('settings:pages.change_password'),
      },
      commission: {
        component: (<Commission />),
        title: t('settings:pages.commission_splits'),
      },
      discounts: {
        component: (<DiscountList />),
        title: t('settings:pages.discounts'),
      },
      'loyalty-program': {
        component: (<LoyaltyForm />),
        title: t('settings:pages.loyalty_program'),
      },
      'waiting-list': {
        component: (<WaitingList />),
        title: t('settings:pages.waiting_list'),
      },
      promo: {
        component: (<PromoCodes />),
        title: t('settings:pages.promo_codes'),
      },
      'auto-payout': {
        component: (<AutoPayout />),
        title: t('settings:pages.auto_payout'),
      },
      'payment-card': {
        component: (<BrandPaymentSettings />),
        title: t('settings:pages.subscription'),
      },
    };

    if (!canUserViewShopDetails(this.props.permissions)) {
      delete pages['edit-shop'];
    }

    return pages;
  }

  fetchBankAccount = () => this.props.fetchBankAccount(this.props.shop);
  deleteBankAccount = () => this.props.deleteBankAccount(this.props.shop);
  fetchDebitCard = () => this.props.fetchDebitCard(this.props.shop);
  fetchBalance = () => this.props.fetchBalance(this.props.shop);
  initiateInstantPayout = () =>
    this.props.initiateInstantPayout(this.props.shop).then(() => {
      this.fetchBalance();
      return showNotification({
        title: t('settings:payout_successful_title'),
        level: 'success',
        message: t('settings:payout_successful_message'),
      });
    });

  render() {
    return (
      <Settings
        pages={this.getPages()}
        page={this.props.page}
      />
    );
  }
}
ShopUserSettingsWrapper.propTypes = {
  fetchBankAccount: PropTypes.func.isRequired,
  deleteBankAccount: PropTypes.func.isRequired,
  shop: PropTypes.string.isRequired,
  page: PropTypes.string,
  permissions: PropTypes.object.isRequired,
  fetchDebitCard: PropTypes.func.isRequired,
  fetchBalance: PropTypes.func.isRequired,
  initiateInstantPayout: PropTypes.func.isRequired,
};
ShopUserSettingsWrapper.defaultProps = {
  page: '',
};

const mapStateToProps = (state, ownProps) => ({
  shop: state.auth.shop,
  permissions: state.auth.permissions,
  page: ownProps.params.page,
});

const mapDispatchToProps = {
  fetchBankAccount: getShopBankAccount,
  deleteBankAccount: deleteShopBankAccount,
  fetchDebitCard: requestShopDebitCard,
  fetchBalance: fetchShopBalance,
  initiateInstantPayout: initiateShopInstantPayout,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopUserSettingsWrapper);
